module.exports = __webpack_public_path__ + "static/media/chinstrap.884c8a9a.png";